// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__2jM2O","input":"Search_input__3iTQH"};